import { colorsPalettes, mixins } from "@similarweb/styles";
import { transitionStyles } from "app/pages/sales-intelligence/pages/home/components/styles";
import { FlexRowFlexEnd } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { StyledLink } from "pro-features/styled components/StyledLink/src/StyledLink";
import styled from "styled-components";

export const StyledAssetLink = styled(StyledLink)`
    ${mixins.setFontVariant("button", colorsPalettes.blue[400])};
    ${transitionStyles("color")};

    &:hover,
    &:active {
        color: ${colorsPalettes.blue[500]};
    }
`;

export const StyledCellWrapper = styled(FlexRowFlexEnd)`
    flex-grow: 1;
    width: 100%;
    user-select: none;
`;
